import React from "react";
import {
    merge as _merge
} from "lodash";

// Require moment with german locale
import moment from "moment";
import "moment/locale/de";
import "moment/locale/fr";

import DayPickerInput from "react-day-picker/DayPickerInput";
import Svg from "../../../svg/Svg";



// Wrapper for react-day-picker component (source: https://github.com/gpbl/react-day-picker)
export default class DayPicker extends React.Component {

    static defaultProps = {
        locale              : "de"
    };

    constructor(props) {
        super(props);

        // Set the current locale
        moment.locale(this.props.locale);

        // Get translations from moment
        this._months = moment.months();
        this._weekdaysLong = moment.weekdays();
        this._weekdaysShort = moment.weekdaysMin();

        this.state = this.initialState();
        this.dayPickerInput = undefined;
    }

    initialState = () => ({
        showDayPicker: false
    });

    handleIconClick = () => {
        // Trick to force to show the calendar if user click on the icon
        this.dayPickerInput.input.focus();
        this.dayPickerInput.handleInputFocus();
    };

    renderDayPicker = () => {
        let newProps = _merge({
            dayPickerProps: _merge({
                months: this._months,
                weekdaysLong: this._weekdaysLong,
                weekdaysShort: this._weekdaysShort,
                firstDayOfWeek: 1
            }, this.props.dayPickerProps)
        }, this.props);

        return (
            <DayPickerInput {...newProps} ref={d => this.dayPickerInput = d}/>
        );
    };

    render = () => (
        <div className="DayPicker-Container">
            <Svg id="fa-calendar" className="DayPicker-icon u-hover-cursor" onClick={this.handleIconClick}/>
            { this.renderDayPicker() }
        </div>
    )
}


// WEBPACK FOOTER //
// ./js/mywort/frontend/components/DayPicker.jsx